document.addEventListener("DOMContentLoaded", function() {
    const accordionItems = document.querySelectorAll('.accordion-item');
    
    accordionItems.forEach((item) => {
      const title = item.querySelector('.accordion-title');
      
      title.addEventListener('click', () => {
        // Close all other accordion items
        accordionItems.forEach((otherItem) => {
          const content = otherItem.querySelector('.accordion-content');
          const [arrowDown, arrowUp] = otherItem.querySelectorAll("img");
          
          if (otherItem !== item) {
            content.style.display = 'none';
            arrowDown.style.display = 'inline';
            arrowUp.style.display = 'none';
          }
        });

        // Toggle the clicked item
        const content = item.querySelector('.accordion-content');
        const [arrowDown, arrowUp] = title.querySelectorAll("img");

        if (content.style.display === 'block') {
          content.style.display = 'none';
          arrowDown.style.display = 'inline';
          arrowUp.style.display = 'none';
        } else {
          content.style.display = 'block';
          arrowDown.style.display = 'none';
          arrowUp.style.display = 'inline';
        }
      });
    });
  });